import React, { memo } from 'react';
import { Plus, Trash2 } from 'lucide-react';
import clsx from 'clsx';

const NestedFormRow = ({
  node,
  depth,
  onChange,
  onDelete,
  onAddChild,
  isParentArray = false,
}) => {
  const isContainer = node.type === "object" || node.type === "array";

  return (
    <div
      className={clsx(
        "flex flex-col mt-2",
        depth > 0 && "ml-6 pl-4 border-l-2 border-border"
      )}
    >
      <div className="flex flex-col sm:flex-row sm:items-center gap-3">
        {/* Key Field */}
        <div className="flex-1 min-w-[150px]">
          <label className="block text-xs font-medium text-text-secondary mb-1">
            {isParentArray ? "Índice (Automático)" : "Llave"}
          </label>
          <input
            type="text"
            className={clsx(
              "w-full px-3 py-2 bg-ninja-gray/50 dark:bg-[#111] border border-border rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-ninja-green focus:border-transparent transition-all dark:text-white",
              isParentArray && "opacity-60 cursor-not-allowed"
            )}
            value={isParentArray ? node.key || "-" : node.key}
            onChange={(e) => onChange(node.id, "key", e.target.value)}
            disabled={isParentArray}
            placeholder={isParentArray ? "-" : "Clave del JSON"}
          />
        </div>

        {/* Type Field */}
        <div className="w-[180px]">
          <label className="block text-xs font-medium text-text-secondary mb-1">Tipo</label>
          <select
            className="w-full px-3 py-2 bg-ninja-gray/50 dark:bg-[#111] border border-border rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-ninja-green focus:border-transparent transition-all dark:text-white"
            value={node.type}
            onChange={(e) => onChange(node.id, "type", e.target.value)}
          >
            <option value="string">Cadena de Texto</option>
            <option value="number">Número</option>
            <option value="boolean">Lógico (Si/No)</option>
            <option value="array">Agregar Listado</option>
            <option value="object">Agregar Propiedad</option>
          </select>
        </div>

        {/* Value Field (if not container) */}
        {!isContainer ? (
          <div className="flex-1 min-w-[200px]">
            <label className="block text-xs font-medium text-text-secondary mb-1">Valor</label>
            {node.type === "boolean" ? (
              <select
                className="w-full px-3 py-2 bg-ninja-gray/50 dark:bg-[#111] border border-border rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-ninja-green focus:border-transparent transition-all dark:text-white"
                value={node.value}
                onChange={(e) => onChange(node.id, "value", e.target.value)}
              >
                <option value="true">Sí</option>
                <option value="false">No</option>
              </select>
            ) : (
              <input
                type={node.type === "number" ? "number" : "text"}
                className="w-full px-3 py-2 bg-ninja-gray/50 dark:bg-[#111] border border-border rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-ninja-green focus:border-transparent transition-all dark:text-white"
                value={node.value}
                onChange={(e) => onChange(node.id, "value", e.target.value)}
                placeholder="Valor"
              />
            )}
          </div>
        ) : (
          <div className="flex-1 flex items-end min-w-[150px]">
            <button
              onClick={() => onAddChild(node.id)}
              className="flex items-center gap-2 px-3 py-2 text-sm font-medium text-ninja-green hover:bg-ninja-greenLight rounded-lg transition-colors mt-5"
            >
              <Plus size={16} />
              {node.type === "array" ? "Agregar Ítem" : "Agregar Propiedad"}
            </button>
          </div>
        )}

        {/* Delete Button */}
        <div className="flex items-end h-[60px] pb-1">
          <button
            onClick={() => onDelete(node.id)}
            className="p-2 text-text-muted hover:text-danger hover:bg-red-50 dark:hover:bg-red-900/20 rounded-lg transition-colors"
            title="Eliminar fila"
          >
            <Trash2 size={18} />
          </button>
        </div>
      </div>

      {/* Children Recursion */}
      {isContainer && node.children && node.children.length > 0 && (
        <div className="mt-2 space-y-2">
          {node.children.map((child) => (
            <NestedFormRow
              key={child.id}
              node={child}
              depth={depth + 1}
              onChange={onChange}
              onDelete={onDelete}
              onAddChild={onAddChild}
              isParentArray={node.type === "array"}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default memo(NestedFormRow);
